import React, { useRef, useState } from 'react';

import classnames from 'classnames';
import PerfectScrollbar from 'react-perfect-scrollbar';

import VerticalNavMenuItems from './VerticalNavMenuItems';
import MenuCompaniesHeader from './header/MenuCompaniesHeader';
import { ROUTE_ADMIN } from '@src/@data/router/consts';
import { useMessages } from '@src/@data/utility/hooks/useMessages';
import { useAuth } from '@src/@data/store/AuthProvider';
import { Link } from 'react-router-dom';

interface Props {
  menu?: JSX.Element;
  menuCollapsed: boolean;
  skin?: string;
}

const Sidebar: React.FC<Props> = ({ menuCollapsed, menu, skin }) => {
  const { messages } = useMessages();
  const { isAdminBooklaUser } = useAuth();
  const [menuHover, setMenuHover] = useState(false);
  const shadowRef = useRef<HTMLDivElement>(null);

  const onMouseEnter = () => {
    if (menuCollapsed) {
      setMenuHover(true);
    }
  };

  const scrollMenu = (container: HTMLElement) => {
    if (!shadowRef.current) {
      return;
    }
    if (container.scrollTop > 0) {
      if (!shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.add('d-block');
      }
    } else {
      if (shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.remove('d-block');
      }
    }
  };

  return (
    <div
      className={classnames('main-menu menu-fixed menu-accordion menu-shadow', {
        expanded: menuHover || !menuCollapsed,
        'menu-light': skin !== 'semi-dark' && skin !== 'dark',
        'menu-dark': skin === 'semi-dark' || skin === 'dark',
      })}
      onMouseEnter={onMouseEnter}
      onMouseLeave={() => setMenuHover(false)}
    >
      {menu ? (
        menu
      ) : (
        <>
          <div
            className={classnames(
              'main-menu-header ml-1 mr-1 mt-1',
              isAdminBooklaUser && 'with-admin-button'
            )}
          >
            {isAdminBooklaUser && (
              <Link to={ROUTE_ADMIN} className="btn btn-primary w-100 mb-1">
                {messages('menu_admin_page_cta')}
              </Link>
            )}
            <MenuCompaniesHeader />
          </div>
          <div className="shadow-bottom" ref={shadowRef} />
          <PerfectScrollbar
            className={classnames(
              'main-menu-content',
              isAdminBooklaUser && 'with-admin-button'
            )}
            options={{ wheelPropagation: false }}
            onScrollY={scrollMenu}
          >
            <ul className="navigation navigation-main mb-2">
              <VerticalNavMenuItems />
            </ul>
          </PerfectScrollbar>
        </>
      )}
    </div>
  );
};

export default Sidebar;
